import { useLanguage } from '@/contexts/LanguageContext';

type DirectAnswerBlockProps = {
  answer: string;
  label?: string;
  className?: string;
};

const DirectAnswerBlock = ({ answer, label, className = '' }: DirectAnswerBlockProps) => {
  const { lang } = useLanguage();
  const defaultLabel = lang === 'tr' ? 'Doğrudan cevap' : 'Direct answer';

  return (
    <aside
      className={`rounded-2xl border border-border/70 bg-card/40 p-6 ${className}`}
      aria-label={label ?? defaultLabel}
    >
      <p className="font-body text-xs tracking-[0.2em] uppercase text-muted-foreground mb-3">
        {label ?? defaultLabel}
      </p>
      <p className="geo-direct-answer font-body text-lg leading-relaxed text-foreground">
        {answer}
      </p>
    </aside>
  );
};

export default DirectAnswerBlock;
